 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import HALFTITLE from '@/components/Halftitle'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/Titlepage'
 import COPYRIGHT from '@/components/Copyright'
 import CONTENTS from '@/components/Contents'
 import INTRODUCTION from '@/components/Introduction'
 import CHAPTER01 from '@/components/Chapter01'
 import CHAPTER02 from '@/components/Chapter02'
 import CHAPTER03 from '@/components/Chapter03'
 import CHAPTER04 from '@/components/Chapter04'
 import CHAPTER05 from '@/components/Chapter05'
 import CHAPTER06 from '@/components/Chapter06'
 import CHAPTER07 from '@/components/Chapter07'
 import CHAPTER08 from '@/components/Chapter08'
 import EPILOGUE from '@/components/Epilogue'
 import LOVE_2 from '@/components/love_2'
 import ABOUTTHEAUTHOR from '@/components/AbouttheAuthor'
 import ABOUTTHEPUBLISHER from '@/components/AboutthePublisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/Halftitle",
 			"name" : "Halftitle",
 			"component" : HALFTITLE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Titlepage",
 			"name" : "Titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/Copyright",
 			"name" : "Copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Chapter01",
 			"name" : "Chapter01",
 			"component" : CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js